export const INDEX_STORE =
  "administrationStores/statisticsStores/systemInformationStores/indexStore";
